import { Form, Header, Overlay, Page, Tab, TabHeader, TabLink } from "../manage/styles";
// import FormInput from "../../input";
import { GetValue } from "../functions";
import { GetIcon } from "../../../../icons";
import { CaseHistoryViewButton, CaseHistoryViewTab, CloseButton, CommentBox, CommentHeader, CommentText, DataHead, DataItem, FileCategory, FileTitle, Head, Profile, TabContainer, TabHead, TabItems, TabList, TabText, Td, Title, TrBody } from "./styles";
import Tabs from "../../tab";
import React, { useCallback, useEffect, useState } from "react";
import { ColumnContainer, RowContainer } from "../../../styles/containers/styles";
import ListTable from "../list";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import FormInput from "../../input";
import { getData, postData, putData } from "../../../../backend/api";
import { Button } from "../../drawer/style";
import { Footer } from "../create/styles";
import ViewFiles from "../../../private/pages/documents/ViewFiles";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { InputContainer, TextArea } from "../../input/styles";
import { generateThumbnail } from "../../../functions/string";
import { ProfileIcon } from "../../../private/common/layout/styels";
import { decryptData, encryptData } from "../../../functions/cryptoUtils";
import CaseActivityLog from "../../../private/pages/whistleblowing/activity-log";
import { dateTimeFormat } from "../../../functions/date";
export const DisplayInformations = ({udpateView, isEditingHandler, customClass, profileImage, attributes, data, formMode, formView, setMessage, setLoaderBox, actions, refresh = () => {},tabName="generalInfo" ,display,api,viewDetails, shortName, whistleblowing}) => {
  const [currentData, setCurrentData] = useState(data??false);
  const [newComment, setNewComment] = useState("");
  const [isHistoryView, setIsHistoryView] = useState(false);
  const [resolvedTabName, setResolvedTabName] = useState(tabName);
  const user = useSelector((state) => state.login)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const sendInvitation = (user) => {
    setLoaderBox(true);
    postData({ user }, "user/send-invitation", dispatch, navigate)
      .then((response) => {
        if (response.status === 200) { 
          setMessage({ type: 1, content: t(response.data.message), proceed: "Okay", code: 200 });
          setCurrentData((prevCurrentData) => ({
            ...prevCurrentData,
            invitationSent: true,
          }));
          refresh();
        } else if (response.status === 404) {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 404 });
        } else {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 500 });
        }
        setLoaderBox(false);
      })
      .catch((error) => {
        setMessage({ type: 1, content: error.message + "Something went wrong!", proceed: "Okay", code: 500 });
        setLoaderBox(false);
      });
  };
  const [t] = useTranslation();
  const { i18n } = useTranslation();
  const [selectedLanguage] = useState(i18n.language || "de");
  const [groupedTabs] = useState(() => {
    const groupedTabsTemp =
      formView === "tabs"
        ? attributes?.length > 0 &&
          attributes.reduce((result, attribute, index) => {
            const tabName = attribute.tab;
            const existingTab = result.find((tab) => tab.tabName === resolvedTabName);
            const attributeTemp = { ...attribute, index };
            if (attribute.tag ?? (attribute.view ?? false)) {
              if (existingTab) {
                existingTab.tabItems.push(attributeTemp);
              } else {
                result.push({ tabName: resolvedTabName, tabItems: [attributeTemp] });
              }
            }
            return result;
          }, [])
        : [];

    // Rearrange tabItems within each tab group
    if(window.innerWidth > 768){
      groupedTabsTemp.forEach((tabGroup) => {
        if(tabGroup.tabName==="personalData"){
          const data1 = [];

          let i = 0;
          let count = Math.ceil(tabGroup.tabItems.length / 2); // Corrected to use Math.ceil
          while (count > i) {
            data1.push(tabGroup.tabItems[i]);
            if (i + count < tabGroup.tabItems.length) {
              data1.push(tabGroup.tabItems[i + count]);
            }
            i++;
          }
          tabGroup.tabItems = data1;
        }
      });
    }

    return groupedTabsTemp;
  });
  const [noGroups, setNoGroups] = useState(() => {
    console.log(formView,attributes);
    let tabItems = formView !== "tabs" ? attributes?.length > 0 && attributes.filter((attribute) => attribute.tag ?? (attribute.view ?? false)) : [];

    // // Rearrange tabItems within each tab group

    const data1 = [];

    // let i = 0;
    // let count = Math.ceil(tabItems.length / 2);
    // while (count > i) {
    //   data1.push(tabItems[i]);
    //   if (i + count < tabItems.length) {
    //     data1.push(tabItems[i + count]);
    //   }
    //   i++;
    // }
    // tabItems = data1;

    return tabItems; // Return the modified tabItems as the initial state
  });

  const addViewCase = async(data)=>{
    if (!data?._id) return;
    if(data?.status==="new") setLoaderBox(true);
    await getData({}, `whistleblowing/${data._id}/view-case`, dispatch, navigate)
      .then((response) => {
        if (response.status === 200) {
          if(data.status !== response?.data?.data?.status){
            setCurrentData((prev) => ({...prev, status: response?.data?.data?.status}))
            refresh();
          }
          // udpateView(0);
        } else if (response.status === 404) {
          // setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
        } else {
          // setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
        }
        // setLoaderBox(false);
      })
      .catch((error) => {
        // setMessage({ type: 1, content: error.message + "Something went wrong!", proceed: "Okay" });
        // setLoaderBox(false);
      }).finally(()=>{
        setLoaderBox(false);
      });
  }

  useEffect(() => {
    const fetc = ()=> {
      let tabItems = formView !== "tabs" ? attributes?.length > 0 && attributes.filter((attribute) => attribute.tag ?? (attribute.view ?? false)) : [];

    // Rearrange tabItems within each tab group

    const data1 = [];

    // let i = 0;
    // let count = Math.ceil(tabItems.length / 2);
    // while (count > i) {
    //   data1.push(tabItems[i]);
    //   if (i + count < tabItems.length) {
    //     data1.push(tabItems[i + count]);
    //   }
    //   i++;
    // }
    // tabItems = data1;

    return tabItems;
    }
    if (attributes?.length > 0) {
      setResolvedTabName(attributes[0].tab ?? tabName);
      setNoGroups(fetc());
    }
  }, [attributes, tabName])

  useEffect(() => {
    if(data){
      setCurrentData(data);
      if(api==="whistleblowing"){
        addViewCase(data);
        getComments(data)
      }
    }
  }, [data])
  

  const objectValueReturn = (data, attribute) => {
    if (attribute.showItem && data[attribute.name]?.[attribute.showItem]) {
      return data[attribute.name][attribute.showItem];
    } 
    else if(attribute.showItem==="locale" && data[attribute.name]){
      return data[attribute.name][sessionStorage.getItem("_lang") ?? "de"];
    }
    else if (!attribute.showItem && data[attribute.name]) {
      // Check if the key of data matches specific known keys
      if (["countryOfBirth", "country", "nationality", "workDays", "religion"].includes(attribute.name)) {
        return data[attribute.name][sessionStorage.getItem("_lang") ?? "de"];
      } 
      else if (attribute.name === "company") {
        return data[attribute.name]?.organization;
      } 
      else if (attribute.name === "terminationBy") {
        return data[attribute.name]?.name;
      } 
      else {
        return data[attribute.name]?.title ?? "Nil";
      }
    } 
    else {
      return "Nil";
    }
  };
  const [searchParams] = useSearchParams();
  const paramValue = searchParams.get('tab');

  const hasTabs = actions?.some((item) => item.type === "subList" && item.element === "button") ?? false;
  const hasFiles = (actions?.some((item) => item.id === "generatePdf" && item.element === "callback") && data?.file) ?? false;
  //theme colors
  const themeColors = useSelector((state) => state.themeColors);
  const [activeTab, setActiveTab] = useState(formView === "tabs" ? (paramValue ? paramValue : (groupedTabs?.length > 0 ? groupedTabs[0].tabName : "generalInfo")) : resolvedTabName);
  const profileImageLink = profileImage?.length > 2 && currentData["photo"] ? process.env.REACT_APP_CDN.toString() + currentData["photo"]?.toString() : `${process.env.REACT_APP_CDN.toString()}uploads/profile/profile.jpg`;

  useEffect(() => {
    if (formView === "tabs") {
      setActiveTab(paramValue ? paramValue : (groupedTabs?.length > 0 ? groupedTabs[0].tabName : "generalInfo"));
    }
  }, [location.pathname, paramValue, formView, groupedTabs]);

  const getComments = async (data) => {
    // Safety Check: We need the ID and the Key
    if (!data?._id || !currentData.caseAesKey) return;

    try {
      let payloadData = { whistleblowingId: data._id };
      
      // 1. Fetch Encrypted Data
      const response = await getData(payloadData, "whistleblowing-comment", dispatch, navigate);

      if (response.status === 200) {
        let decryptedList = [];

        // 2. Decrypt in Parallel
        if (response.data && response.data.data && Array.isArray(response.data.data)) {
          decryptedList = await Promise.all(
            response.data.data.map(async (item) => {
              try {
                // Decrypt the comment using the Case Key
                const plainText = await decryptData(item.comment, currentData.caseAesKey);
                return { ...item, comment: plainText };
              } catch (err) {
                console.error("Failed to decrypt comment:", err);
                return { ...item, comment: "⚠️ Decryption Error" };
              }
            })
          );
        }

        // 3. Update State with DECRYPTED data
        setCurrentData({ ...currentData, comments: decryptedList });

      } else if (response.status === 404) {
        // Handle 404 (e.g., no comments found yet is usually not an error, just empty list)
        // setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
      } else {
        // setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
      }
    } catch (error) {
      console.error("Get Comments Error:", error);
      // setMessage({ type: 1, content: "Failed to load comments", proceed: "Okay" });
    }
  };

  const handleCommentSubmit = async (e) => {
    e.preventDefault();
    
    if (!newComment.trim()) return;
    
    // Safety Check: Cannot send if we don't have the key
    if (!currentData.caseAesKey) {
      setMessage({ type: 1, content: "Security Key missing. Cannot send message.", proceed: "Okay", code: 500 });
      return;
    }

    try {
      // 1. Encrypt the Comment
      // The server expects a string (IV + Ciphertext combined)
      const encryptedBlob = await encryptData(newComment, currentData.caseAesKey);

      let payload = {
        user: user?.data?.user?._id, // Might be null for Whistleblower, which is fine
        comment: encryptedBlob,      // SEND ENCRYPTED DATA
        whistleblowingId: currentData._id
      };

      // 2. Send to Server
      const response = await postData(payload, `whistleblowing-comment`, dispatch, navigate);

      if (response.status === 200) {
        let newCommentObj = { ...response.data.data };

        // 3. UI Optimization (Crucial Step)
        // The server returned the ENCRYPTED comment object.
        // Instead of decrypting it again, we just use the 'newComment' state 
        // (which is plain text) for instant display.
        newCommentObj.comment = newComment; 
        newCommentObj.user = user.data?.user; // Ensure user profile is attached for display

        // Append to local list
        const updatedList = [...(currentData.comments || []), newCommentObj];
        
        setCurrentData({ ...currentData, comments: updatedList });
        setNewComment(""); // Clear input
        
      } else if (response.status === 404) {
        setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 404 });
      } else {
        setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 500 });
      }
    } catch (error) {
      console.error("Submit Error:", error);
      setMessage({ type: 1, content: "Failed to send message.", proceed: "Okay", code: 500 });
    }
  };

  const [docsCategory, setDocsCategory] = useState([]);
  const [selectedDocsCategory, setSelectedDocsCategory] = useState("");

  const docType = async()=>{
    try {
      await getData({}, `files/type/${currentData._id}`, dispatch, navigate)
      .then((response) => {
        if (response.status === 200) {
          setDocsCategory(response.data.data);
          setSelectedDocsCategory(response.data.data[0]?._id);
          // udpateView(0);
        } else if (response.status === 404) {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 404 });
        } else {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 500 });
        }
        // setLoaderBox(false);
      })
      .catch((error) => {
        // setMessage({ type: 1, content: error.message + "Something went wrong!", proceed: "Okay" });
        // setLoaderBox(false);
      });
    
    } catch (error) {
      
    }
  }

  useEffect(() => {
    if(actions?.filter(action => action.title === "files").length > 0 && currentData._id){
      docType()
    }
  }, [actions,currentData])
  
  return (
    <TrBody className={`${formView === "tabs" ? "" : formMode} ${customClass ?? ""}`}>
      {shortName==="caseReports" && api==="whistleblowing" && <CaseHistoryViewTab>
        <CaseHistoryViewButton onClick={()=> setIsHistoryView(true)}>
          <GetIcon icon={"history"} fontSize={18} color="#FFFFFF" />
          {t("viewHistory")}
        </CaseHistoryViewButton>
      </CaseHistoryViewTab>}
      {isHistoryView && <CaseActivityLog t={t} caseId={data?._id} themeColors={themeColors} closeModal={() => setIsHistoryView(false)} dispatch={dispatch} navigate={navigate} />}
      {formView === "tabs" ? (
        <TabContainer className="vertical">
          <TabHeader className="vertical mh">
            {profileImage && <Profile className={`${currentData.photo ? "photo" : ""}`}>
              <ProfileIcon className={`${currentData.photo ? "photo" : ""}`} style={{margin:'10px 0'}}>{generateThumbnail(currentData?.fullName ?? "", null, currentData.photo ?? "", "profile")}</ProfileIcon>
              <h6>{`${currentData["firstName"]} ${currentData["lastName"]}`}</h6>
              <ColumnContainer className="buttons">
                {isEditingHandler && (
                  <button onClick={() => isEditingHandler(currentData, udpateView)}>
                    <GetIcon icon={"edit"}></GetIcon>
                  </button>
                )}
                {isEditingHandler && currentData.mobileNumber && (
                  <button onClick={() => (window.location.href = `tel:${currentData.mobileNumber}`)}>
                    <GetIcon icon={"call"}></GetIcon>
                  </button>
                )}
              </ColumnContainer>
            </Profile>}
            <TabList>
              {groupedTabs.map((group) => {
                if(group.tabName==="official"){
                  let item = actions?.find((val) => val.type === "subList" && val.element === "button" && val?.title==="salary")
                  return (
                    <>
                  <React.Fragment key={group.tabName}>
                    <TabLink
                      key={`main-` + group.tabName}
                      theme={themeColors}
                      className={activeTab === group.tabName && "active"}
                      onClick={() => {
                        setActiveTab(group.tabName);
                      }}
                    >
                      <TabText> {t(group.tabName)}</TabText>
                    </TabLink>
                  </React.Fragment>
                  {item &&<TabLink
                  key={`main-` + item?.title}
                  theme={themeColors}
                  className={activeTab === item?.title && "active"}
                  onClick={() => {
                    setActiveTab(item?.title);
                  }}
                >
                  <TabText> {t(item?.title)}</TabText>
                </TabLink>}
                </>
                  )
                }
                else{
                return <React.Fragment key={group.tabName}>
                  {group.tabItems?.length > 0 && (
                    <TabLink
                      key={`main-` + group.tabName}
                      theme={themeColors}
                      className={activeTab === group.tabName && "active"}
                      onClick={() => {
                        setActiveTab(group.tabName);
                      }}
                    >
                      <TabText> {t(group.tabName)}</TabText>
                    </TabLink>
                  )}
                </React.Fragment>
                }
              })}
              {actions?.map((item) => {
                return (
                  item.type === "subList" &&
                  item.element === "button" && item?.title!=="salary" && (
                    <TabLink
                      key={`main-` + item?.title}
                      theme={themeColors}
                      className={activeTab === item?.title && "active"}
                      onClick={() => {
                        setActiveTab(item?.title);
                      }}
                    >
                      <TabText> {t(item?.title)}</TabText>
                    </TabLink>
                  )
                );
              })}
            </TabList>
          </TabHeader>
          <TabItems>
            {groupedTabs.map((group) => {
              if(group.tabName==="official" || group.tabName==="socialInsurance"){
                let item = actions?.find((val) => val.type === "subList" && val.element === "button" && val?.title==="salary")
                const groupedData = [];
                let currentGroup = null;

                // Step 1: Group the items by title
                group.tabItems.forEach(item => {
                  if (item.type === 'title') {
                    currentGroup = { title: item.title, fields: [item] };
                    groupedData.push(currentGroup);
                  } else if (currentGroup) {
                    currentGroup.fields.push(item);
                  }
                });

                // Step 2: Initialize left and right with first and last groups
                const left = [], right = [];
                let leftFieldCount = 0, rightFieldCount = 0;

                if (groupedData.length > 0) {
                  const firstGroup = groupedData.shift(); // removes and returns first
                  left.push(firstGroup);
                  leftFieldCount += firstGroup.fields.length;
                }

                if (groupedData.length > 0) {
                  const lastGroup = groupedData.pop(); // removes and returns last
                  right.push(lastGroup);
                  rightFieldCount += lastGroup.fields.length;
                }

                // Step 3: Distribute remaining groups based on field count
                groupedData.forEach(group => {
                  const fieldCount = group.fields.length;
                  if (leftFieldCount <= rightFieldCount) {
                    left.push(group);
                    leftFieldCount += fieldCount;
                  } else {
                    right.push(group);
                    rightFieldCount += fieldCount;
                  }
                });

              // console.log(left, right, leftCount, rightCount);
                return (<>
                  <Tab className="sub" key={`sub-${group.tabName}`} active={activeTab === group.tabName}>
                {api!=="news" && <TabHead>{t(group.tabName)}</TabHead>}
                <Form className={`vertical sub ${formMode}`}>
                <div>
                  {left.length > 0 && left.map((leftData, index) => (
                  leftData.fields?.length > 0 &&
                  leftData.fields.map((attribute, index) => {
                    if(attribute.type === "multiSelect")
                      console.log(attribute, data);
                      if (attribute.tag ?? (attribute.view ?? false)) {
                        try {
                          let itemValue;
                          if (attribute.type === "expired" && attribute.showItem === "contractEnd") {
                            if (data.contractEnd === null && data.contractFrom !== null) {
                                itemValue = new Date(data.contractFrom) <= new Date() ? new Date(new Date().setDate(new Date().getDate() + 1)) : null;
                            } else if (data.contractEnd === null && data.contractFrom === null) {
                                itemValue = new Date(new Date().setDate(new Date().getDate() + 1));
                            } else {
                              itemValue = new Date(data.contractEnd) >= new Date() ? new Date(data.contractEnd) : null;
                            }
                          } else if (attribute.collection?.length > 0 && attribute.showItem?.length > 0) {
                            itemValue = data[attribute.collection]?.[attribute.showItem];
                          } else {
                            itemValue = data[attribute.name];
                          }
                          if (attribute.type === "select" && attribute?.showItem === "locale") {
                            itemValue = attribute.showItem?.length > 0 ? currentData[attribute.name][selectedLanguage] : currentData[attribute.name];
                          }
                          if (attribute.type === "invitation") {
                            return (
                              <Td key={index}>
                                <Title>{t(attribute.label)}</Title>
                                <DataItem>
                                  {currentData["invitationSent"] ?? false ? (
                                    <>
                                      <FormInput
                                        onChange={() => {
                                          sendInvitation(currentData["_id"]);
                                        }}
                                        type="submit"
                                        value={t("resendInvitation")}
                                        disabled={currentData["email"] ? false : true}
                                      ></FormInput>
                                    </>
                                  ) : (
                                    <FormInput
                                      onChange={() => {
                                        sendInvitation(currentData["_id"]);
                                      }}
                                      type="submit"
                                      value={t("sendInvitation")}
                                      disabled={currentData["email"] ? false : true}
                                    ></FormInput>
                                    
                                  )}
                                </DataItem>
                              </Td>
                            );
                          }
                          if (attribute.type === "title") {
                            return (
                              <Td className="bold" key={index}>
                                <Title className="bold">{t(attribute.title)}</Title>
                              </Td>
                            );
                          }
                          return (
                            <Td key={index}>
                              <Title>{t(attribute.label)}</Title>
                              <DataItem>{GetValue(attribute, itemValue, true)}{(attribute.name==="hoursAtLeast" || attribute.name === "hoursMaximum" || attribute.name === "hoursTarget")&&(" "+ t("Hours"))}</DataItem>
                            </Td>
                          );
                        } catch (error) {
                          return (
                            <Td key={index}>
                              <Title>{t(attribute.label)}</Title>
                              <DataItem>--</DataItem>
                            </Td>
                          );
                        }
                      }

                      return null; // Return null if the condition is not met, to avoid rendering unwanted elements
                    })))}
                    </div>
                <div>
                {right.length > 0 && right.map((leftData, index) => (
                  leftData.fields?.length > 0 &&
                  leftData.fields.map((attribute, index) => {
                    if(attribute.type === "multiSelect")
                      console.log(attribute, data);
                      if (attribute.tag ?? (attribute.view ?? false)) {
                        try {
                          let itemValue;
                          if (attribute.type === "expired" && attribute.showItem === "contractEnd") {
                            if (data.contractEnd === null && data.contractFrom !== null) {
                                itemValue = new Date(data.contractFrom) <= new Date() ? new Date(new Date().setDate(new Date().getDate() + 1)) : null;
                            } else if (data.contractEnd === null && data.contractFrom === null) {
                                itemValue = new Date(new Date().setDate(new Date().getDate() + 1));
                            } else {
                              itemValue = new Date(data.contractEnd) >= new Date() ? new Date(data.contractEnd) : null;
                            }
                          } else if (attribute.collection?.length > 0 && attribute.showItem?.length > 0) {
                            itemValue = data[attribute.collection]?.[attribute.showItem];
                          } else {
                            itemValue = data[attribute.name];
                          }
                          if (attribute.type === "select" && attribute?.showItem === "locale") {
                            itemValue = attribute.showItem?.length > 0 ? currentData[attribute.name][selectedLanguage] : currentData[attribute.name];
                          }
                          if (attribute.type === "invitation") {
                            return (
                              <Td key={index}>
                                <Title>{t(attribute.label)}</Title>
                                <DataItem>
                                  {currentData["invitationSent"] ?? false ? (
                                    <>
                                      <FormInput
                                        onChange={() => {
                                          sendInvitation(currentData["_id"]);
                                        }}
                                        type="submit"
                                        value={t("resendInvitation")}
                                        disabled={currentData["email"] ? false : true}
                                      ></FormInput>
                                    </>
                                  ) : (
                                    <FormInput
                                      onChange={() => {
                                        sendInvitation(currentData["_id"]);
                                      }}
                                      type="submit"
                                      value={t("sendInvitation")}
                                      disabled={currentData["email"] ? false : true}
                                    ></FormInput>
                                    
                                  )}
                                </DataItem>
                              </Td>
                            );
                          }
                          if (attribute.type === "title") {
                            return (
                              <Td className="bold" key={index}>
                                <Title className="bold">{t(attribute.title)}</Title>
                              </Td>
                            );
                          }
                          return (
                            <Td key={index}>
                              <Title>{t(attribute.label)}</Title>
                              <DataItem>{GetValue(attribute, itemValue, true)}{(attribute.name==="hoursAtLeast" || attribute.name === "hoursMaximum" || attribute.name === "hoursTarget")&&(" "+ t("Hours"))}</DataItem>
                            </Td>
                          );
                        } catch (error) {
                          return (
                            <Td key={index}>
                              <Title>{t(attribute.label)}</Title>
                              <DataItem>--</DataItem>
                            </Td>
                          );
                        }
                      }

                      return null; // Return null if the condition is not met, to avoid rendering unwanted elements
                    })))}
                    </div>
                </Form>
                  </Tab>
                  {item && currentData && currentData?._id && <Tab className="sub" key={`sub-${item?.title}`} active={activeTab === item?.title}>
                    <ListTable setMessage={setMessage} setLoaderBox={setLoaderBox} referenceId={currentData?._id} attributes={item?.attributes} {...item.params} shortName={item?.title} listHeadClass={"static"} viewDetails={viewDetails}></ListTable>
                  </Tab>}
              </>)
              }
              else{
                return <Tab className="sub" key={`sub-${group.tabName}`} active={activeTab === group.tabName}>
                {api!=="news" && <TabHead>{t(group.tabName)}</TabHead>}
                <Form className={`vertical sub ${formMode}`}>
                  {group.tabItems?.length > 0 &&
                    group.tabItems.map((attribute, index) => {
                      if(attribute.type === "multiSelect")
                      console.log(attribute, data);
                      if(!(currentData.companyRoster) && (attribute.name==="timeRecordWithoutRoaster" || attribute.name==="timeRecordWithShiftRoaster"))
                        return null;
                      if (attribute.tag ?? (attribute.view ?? false)) {
                        try {
                          let itemValue;
                          if (attribute.type === "expired" && attribute.showItem === "contractEnd") {
                            if(data.authorisation && data.authorisation.toLowerCase() === "admin"){
                              itemValue = new Date(new Date().setDate(new Date().getDate() + 1));
                            } else if (data.contractEnd === null && data.contractFrom !== null) {
                                itemValue = new Date(data.contractFrom) <= new Date() ? new Date(new Date().setDate(new Date().getDate() + 1)) : null;
                            } else if (data.contractEnd === null && data.contractFrom === null) {
                                itemValue = new Date(new Date().setDate(new Date().getDate() + 1));
                            } else {
                              itemValue = new Date(data.contractEnd) >= new Date() ? new Date(data.contractEnd) : null;
                            }
                          } else if (attribute.collection?.length > 0 && attribute.showItem?.length > 0) {
                            itemValue = data[attribute.collection]?.[attribute.showItem];
                          } else if (attribute.collection?.length === 0 && attribute.showItem?.length > 0) {
                            itemValue = data[attribute.showItem];
                          } else {
                            itemValue = data[attribute.name];
                          }
                          if (attribute.type === "select" && attribute?.showItem === "locale") {
                            itemValue = attribute.showItem?.length > 0 ? currentData[attribute.name][selectedLanguage] : currentData[attribute.name];
                          }
                          if (attribute.type === "invitation") {
                            return (
                              <Td key={index}>
                                <Title>{t(attribute.label)}</Title>
                                <DataItem>
                                  {currentData["invitationSent"] ?? false ? (
                                    <>
                                      <FormInput
                                        onChange={() => {
                                          sendInvitation(currentData["_id"]);
                                        }}
                                        type="submit"
                                        value={t("resendInvitation")}
                                        disabled={currentData["email"] ? false : true}
                                      ></FormInput>
                                    </>
                                  ) : (
                                    <FormInput
                                      onChange={() => {
                                        sendInvitation(currentData["_id"]);
                                      }}
                                      type="submit"
                                      value={t("sendInvitation")}
                                      disabled={currentData["email"] ? false : true}
                                    ></FormInput>
                                    
                                  )}
                                </DataItem>
                              </Td>
                            );
                          }
                          if (attribute.type === "title") {
                            return (
                              <Td className="bold" key={index}>
                                <Title className="bold">{t(attribute.title)}</Title>
                              </Td>
                            );
                          }
                          return (
                            <Td key={index}>
                              <Title>{t(attribute.label)}</Title>
                              <DataItem>{GetValue(attribute, itemValue, true)}{(attribute.name==="hoursAtLeast" || attribute.name === "hoursMaximum" || attribute.name === "hoursTarget")&&(" "+ t("Hours"))}</DataItem>
                            </Td>
                          );
                        } catch (error) {
                          return (
                            <Td key={index}>
                              <Title>{t(attribute.label)}</Title>
                              <DataItem>--</DataItem>
                            </Td>
                          );
                        }
                      }

                      return null; // Return null if the condition is not met, to avoid rendering unwanted elements
                    })}
                </Form>
                </Tab>
              }
            })}
            {currentData && currentData?._id && actions?.map((item) => {
              return (
                item.type === "subList" &&
                item.element === "button" && item?.title!=="salary" && (
                  <Tab className={`sub ${item.title}`} key={`sub-${item?.title}`} active={activeTab === item?.title}>
                    {item.title==="files" && <FileCategory>
                      <FileTitle>{t("category")}</FileTitle>
                      <div style={{borderBottom:'2px solid #d6e0ff', marginBottom:'10px'}}></div>
                        {Array.isArray(docsCategory) && docsCategory?.map((val,idx) => (
                          <TabLink
                        key={`docs-type-` + idx}
                        theme={themeColors}
                        className={`${selectedDocsCategory === val?._id && "active"} files `}
                        onClick={() => {
                          setSelectedDocsCategory(val?._id);
                        }}
                      >
                        <TabText> {t(sessionStorage.getItem("_lang") ? val?.[sessionStorage.getItem("_lang")] : val?.de ? val?.de : val?.en)}</TabText>
                        <TabText className={`fileCount ${selectedDocsCategory === val?._id && "active"}`} >{val?.fileCount}</TabText>
                      </TabLink>
                        ))}
                        
                    </FileCategory>}
                    <ListTable setMessage={setMessage} setLoaderBox={setLoaderBox} referenceId={currentData?._id} attributes={item.attributes} {...item.params} shortName={item?.title} listHeadClass={"static"} viewDetails={viewDetails} selectedDocsCategory={item.title==="files" && selectedDocsCategory} ></ListTable>
                  </Tab>
                )
              );
            })}
          </TabItems>
        </TabContainer>
      ) : (
        <TabContainer className={`vertical ${(hasFiles && shortName!=="caseReports") ? "files":""}`}>
          {hasTabs && (
            <TabHeader className="vertical mh">
              <TabList>
                <TabLink
                  key={`main-generalInfo`}
                  theme={themeColors}
                  className={activeTab === resolvedTabName && "active"}
                  onClick={() => {
                    setActiveTab(resolvedTabName);
                  }}
                >
                  <TabText> {t(resolvedTabName)}</TabText>
                </TabLink>
                {actions?.map((item) => {
                  return (
                    item.type === "subList" &&
                    item.element === "button" && (
                      <TabLink
                        key={`main-` + item?.title}
                        theme={themeColors}
                        className={activeTab === item?.title && "active"}
                        onClick={() => {
                          setActiveTab(item?.title);
                        }}
                      >
                        <TabText> {t(item?.title)}</TabText>
                      </TabLink>
                    )
                  );
                })}
              </TabList>
            </TabHeader>
          )}
          <TabItems className={`${hasTabs}`}>
            <Tab className={`sub ${hasTabs}`} key={`sub-generalInfo`} active={activeTab === tabName}>
              {(api==="news" || api==="news/employee-news") ? <TabHead className={`${display ?? ""}`}>{t(currentData?.title ?? tabName)} </TabHead> : <TabHead className={`${display ?? ""}`}>{t(tabName)} {isEditingHandler && display && (
                  <Button style={{maxWidth:'50px'}} onClick={() => isEditingHandler(currentData, udpateView)}>
                    <GetIcon icon={"edit"}></GetIcon>
                  </Button>
                )} </TabHead>}
              <Form className={`vertical sub ${formMode}`}>
                {noGroups.map((attribute, index) => {
                  // try {
                  let itemValue;
                  if (attribute.type === "select" && !(attribute.collection) && attribute?.showItem === "locale") {
                            itemValue = currentData?.[attribute.name]?.[selectedLanguage] ?? currentData?.[attribute.name] ?? "--";
                  } else{
                    itemValue = attribute.collection?.length > 0 && attribute.showItem?.length > 0 
                        ? currentData?.[attribute.collection]?.[attribute.showItem] 
                        : attribute.name === "" ? "" : currentData?.[attribute.name] ?? "--";
                  }

                  let dynamicClass = "";
                  if (attribute.condition) {
                    if (currentData[attribute.condition.item] === attribute.condition.if) {
                      dynamicClass = attribute.condition.then;
                    } else {
                      dynamicClass = attribute.condition.else;
                    }
                  }

                  if(attribute.type === "multiSelect"){
                    itemValue = currentData?.[attribute.name]
                  }

                  if(dynamicClass === "disabled") {
                    return null;
                  }

                  console.log("attribute", attribute.type, currentData[attribute.name]);
                  
                    if (attribute.type === "invitation") {
                            return (
                              <Td key={index}>
                                <Title>{t(attribute.label)}</Title>
                                <DataItem>
                                  {currentData["invitationSent"] ?? false ? (
                                    <>
                                      <FormInput
                                        onChange={() => {
                                          sendInvitation(currentData["_id"]);
                                        }}
                                        type="submit"
                                        value={t("resendInvitation")}
                                        disabled={currentData["email"] ? false : true}
                                      ></FormInput>
                                    </>
                                  ) : (
                                    <FormInput
                                      onChange={() => {
                                        sendInvitation(currentData["_id"]);
                                      }}
                                      type="submit"
                                      value={t("sendInvitation")}
                                      disabled={currentData["email"] ? false : true}
                                    ></FormInput>
                                    
                                  )}
                                </DataItem>
                              </Td>
                            );
                          }

                    if (attribute.type === "title") {
                      return (
                        <Td className="bold" key={index}>
                          <Title className="bold">{t(attribute.title)}</Title>
                        </Td>
                      );
                    }

                    return (
                      <Td className={`${(attribute.type === "textarea" && (api==="faqs" || api==="news/employee-news")) ? "textarea-item" : ""} ${attribute.name==="" ? "no-border": ""}`} key={index}>
                        <Title>{t(attribute.label)}</Title>
                        <DataItem>{(!(attribute.showItem) && typeof itemValue ==="object") ? objectValueReturn(currentData,attribute) : GetValue(attribute, itemValue, true)} </DataItem>
                      </Td>
                    );
                  // } catch (error) {
                  //   return (
                  //     <Td key={index}>
                  //       <Title>{t(attribute.label)}</Title>
                  //       <DataItem>{`--`} </DataItem>
                  //     </Td>
                  //   );
                  // }
                })}
              </Form>

              {/* Custom Fields Section */}
              {shortName==="caseReports" && currentData?.customFields && currentData.customFields.length > 0 && (
                <Form className={`vertical sub ${formMode} custom-fields`}>
                  {/* <Td className="bold">
                    <Title className="bold">{t("Custom Fields")}</Title>
                  </Td> */}
                  {currentData.customFields.map((customField, index) => {
                    const lang = sessionStorage.getItem("_lang") || "de";
                    const fieldType = customField.fieldId?.fieldType || 'text';
                    const rawValue = customField.value;

                    // Get label from populated fieldId
                    const fieldLabel = customField.fieldId?.labels?.[lang] || 
                                       customField.fieldId?.labels?.de || 
                                       customField.fieldKey || 
                                       `Field ${index + 1}`;

                    // Format display value based on field type
                    let displayValue = rawValue || '--';

                    if (rawValue) {
                      switch (fieldType) {
                        case 'date':
                          // Format date value
                          try {
                            const dateObj = new Date(rawValue);
                            if (!isNaN(dateObj.getTime())) {
                              displayValue = dateObj.toLocaleDateString('de-DE', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric'
                              });
                            }
                          } catch (e) {
                            displayValue = rawValue;
                          }
                          break;

                        case 'select':
                        case 'radio':
                          // Try to find the label for the selected option
                          const options = customField.fieldId?.options || [];
                          const selectedOption = options.find(opt => opt.value === rawValue);
                          if (selectedOption) {
                            displayValue = selectedOption.labels?.[lang] || 
                                          selectedOption.labels?.de || 
                                          selectedOption.value || 
                                          rawValue;
                          }
                          break;

                        case 'file':
                          // Display as a clickable link or file indicator
                          displayValue = <a href={rawValue} target="_blank" rel="noopener noreferrer">📎 {t("View File")}</a>;
                          break;

                        case 'email':
                          displayValue = <a href={`mailto:${rawValue}`}>{rawValue}</a>;
                          break;

                        case 'number':
                          // Format number
                          displayValue = Number(rawValue).toLocaleString(lang === 'de' ? 'de-DE' : 'en-US');
                          break;

                        case 'textarea':
                          // Preserve line breaks for textarea
                          displayValue = <span style={{ whiteSpace: 'pre-wrap' }}>{rawValue}</span>;
                          break;

                        default:
                          // text, email, etc - display as is
                          displayValue = rawValue;
                      }
                    }

                    return (
                      <Td className={`custom-field-${index}`} key={`custom-${index}`}>
                        <Title>{fieldLabel}</Title>
                        <DataItem>{displayValue}</DataItem>
                      </Td>
                    );
                  })}
                </Form>
              )}

              {hasFiles && shortName==="caseReports" && <ViewFiles customClass={`large ${shortName}`} admin={user.data.user.authorisation === "advisor" || user.data.user.authorisation === "admin"} page={{data: currentData}} setLoaderBox={setLoaderBox} title={"attendanceToday"} popup={false}></ViewFiles>}
              {shortName==="caseReports" && <div style={{position:'relative', textAlign:'center'}}>
                    <p style={{fontSize:'18px', fontWeight:'bold'}}>{"Whistleblowing "+t("comments")}</p>
                  {/* <div style={{margin:"0 30px",marginBottom:"170px", overflowY:'auto', maxHeight:'300px'}}> */}
                  <div style={{margin:"0 30px"}}>
                {Array.isArray(currentData?.comments) && currentData?.comments?.map((item,index) => (
                  <div key={index} style={{display:'flex', justifyContent: (item.user && item.user._id===user?.data?.user?._id) ? 'flex-end' : 'flex-start'}}>
                  <CommentBox>
                    <CommentHeader style={{ textAlign: (item.user && item.user._id===user?.data?.user?._id) ? 'end' : 'start' }}>
                      {(item.user && item.user._id===user?.data?.user?._id) ? t("you") : item?.user?.fullName ? item?.user?.fullName : t("Unknown Employee")} - {item.createdAt && dateTimeFormat(item.createdAt)}
                    </CommentHeader>
                    <CommentText>{item?.comment}</CommentText>
                  </CommentBox>
                  </div>
                ))}
                </div>
                {/* <Form style={{position:"absolute", bottom: 0, left: 0, right: 0}} className={`vertical sub ${formMode}`}> */}
                <Form  className={`vertical sub ${formMode}`}>
                  <InputContainer>
                    <TextArea style={{margin:"10px 30px", width:'auto', fontSize:'16px'}} theme={themeColors} className={`input`} placeholder={`${t("addAComment")}`} value={newComment} onChange={(e) => setNewComment(e.target.value)} />
                  </InputContainer>
                  <Button onClick={handleCommentSubmit} style={{margin:"10px 30px", width:'auto',fontSize:"17px", fontWeight:"600"}}>{t("Add Comment")}</Button>
                </Form>
                </div>}
            </Tab>
            {currentData && currentData?._id && actions?.map((item) => {
              return (
                item.type === "subList" &&
                item.element === "button" && (
                  <Tab className="sub" key={`sub-new-${item?.title}`} active={activeTab === item?.title}>
                    <ListTable setMessage={setMessage} setLoaderBox={setLoaderBox} referenceId={currentData?._id} attributes={item.attributes} {...item.params} shortName={item?.title} listHeadClass={"static"} viewDetails={viewDetails}></ListTable>
                  </Tab>
                )
              );
            })}
          </TabItems>

          {shortName==="caseReports" && 
             <div style={{flex: 1, padding: "10px 0"}}>
              {whistleblowing}
             </div>
          }

          {hasFiles && shortName!=="caseReports" && <ViewFiles customClass="large" page={{data: currentData}} setLoaderBox={setLoaderBox} title={"attendanceToday"} popup={false}></ViewFiles>}
        </TabContainer>
      )}
    </TrBody>
  );
};
const Popup = ({ formMode, viewMode, themeColors, openData, setLoaderBox, setMessage, closeModal, itemTitle , actionButton,actionFunction}) => {
  const [t] = useTranslation();
  const titleValue = (itemTitle.collection?.length > 0 ? openData?.data?.[itemTitle.collection]?.[itemTitle.name] ?? "" : openData?.data?.[itemTitle.name]) || "Please update the itemTitle.";
  console.log("Mesage1", setMessage);
  const tabHandler = useCallback(() => {
    const tempTab = openData.actions
      .filter((item) => item.type === "subList" || item.type === "subItem")
      .map((item, index) => ({
        name: `${item.id}-${index}`,
        title: item?.title,
        element: <ListTable viewMode={item.type ?? "subList"} setMessage={setMessage} setLoaderBox={setLoaderBox} parentReference={item?.params?.parentReference} referenceId={openData?.data?._id} attributes={item.attributes} {...item.params}></ListTable>,
      }));
    tempTab.unshift({
      name: `information-${titleValue}`,
      title: "Informations",
      element: (
        <TabContainer>
          <Head>
            <DataHead>
              <GetIcon icon={""}></GetIcon>
              <span>Basic Details</span>
            </DataHead>
          </Head>
          <DisplayInformations setMessage={setMessage} setLoaderBox={setLoaderBox} formMode={formMode} attributes={openData.attributes} data={openData.data} />
        </TabContainer>
      ),
    });
    setTabs(tempTab);
  }, [setMessage, setLoaderBox, openData, formMode, titleValue]);

  const [tabs, setTabs] = useState([]);
  console.log("openData", openData);
  useEffect(() => {
    tabHandler();
  }, [tabHandler]);

  return (
    <Overlay>
      <Page className={`${openData?.item?.params?.customClass ?? "medium"} popup-child sub-page`}>
        <Header>
          <span>{`${GetValue(itemTitle, titleValue)}`}</span>
          <CloseButton theme={themeColors} onClick={closeModal}>
            <GetIcon icon={"Close"} />
          </CloseButton>
        </Header>
        <RowContainer theme={themeColors} className="popup-data">
          {tabs.length > 0 && <Tabs tabs={tabs}></Tabs>}
        </RowContainer>
      </Page>
    </Overlay>
  );
};
export default Popup;
